/** Convert ISO / Date to datetime-local input value (store-local wall clock). */
export function toDateTimeLocalValue(value?: string | Date | null): string {
  const date = value ? new Date(value) : new Date();
  if (!Number.isFinite(date.getTime())) return '';
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
}

/** Convert datetime-local value to ISO string for the API. */
export function fromDateTimeLocalValue(raw: string): string {
  const d = new Date(raw);
  if (!Number.isFinite(d.getTime())) throw new Error('Invalid date');
  return d.toISOString();
}
